import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { APPLY_ROUTE, LOGIN_ROUTE, withBase } from '../../publicSite/config';
import { trackEvent } from '../../publicSite/analytics';

const links = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Academics', to: '/academics/faculties' },
  { label: 'Admissions', to: '/admissions' },
  { label: 'Events', to: '/events' }
];

export default function Navbar({ onToggleMobile, mobileOpen, hidden, menuButtonRef }) {
  return (
    <div className={`ps-header ${hidden ? 'is-hidden' : ''}`.trim()}>
      <div className="ps-header-inner">
        <Link to={withBase('/')} className="ps-logo">
          <div className="ps-logo-mark" aria-hidden="true">
            <img src="/logos/shem_logo_transparent.png" alt="" />
          </div>
          <div>
            <div className="ps-logo-title">School of SHEM</div>
            <div className="ps-logo-subtitle">Wisdom · Stewardship · Mastery</div>
          </div>
        </Link>

        <nav className="ps-nav" aria-label="Main navigation">
          {links.map((link) => (
            <NavLink
              key={link.label}
              to={withBase(link.to)}
              end={link.to === '/'}
              className={({ isActive }) => `ps-nav-button ${isActive ? 'is-active' : ''}`}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="ps-header-actions">
          <Link
            to={withBase(LOGIN_ROUTE)}
            className="ps-sign-in"
            onClick={() => trackEvent('cta_click', { label: 'header_login' })}
          >
            Sign In
          </Link>
          <Link
            to={withBase(APPLY_ROUTE)}
            className="btn btn-primary btn-sm"
            onClick={() => trackEvent('cta_click', { label: 'header_apply' })}
          >
            Apply
          </Link>
        </div>

        <button
          type="button"
          className="ps-burger"
          aria-label={mobileOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={mobileOpen}
          aria-controls="public-mobile-navigation"
          onClick={onToggleMobile}
          ref={menuButtonRef}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </div>
  );
}
